/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  /*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  */

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  async function updateLocationTags(){
    const response = await fetch("https://pro.ip-api.com/json/?fields=country,regionName,zip,city&key=3vlBzaNm31rqDCj")
    const location = await response.json();
    
    let deliveryText;
          if(["North Vancouver","Surrey","Chilliwack","Kamloops","Hope","Aggasiz","West Vancouver","Gibsons","Sechelt","Roberts Creek","Campbell River","Bend","Nanaimo","Victoria","Duncan","Port Alberni","Tofino","Ucluelet","Bowen Island","Sydney","Port Coquitlam","Langley","Cloverdale","Whistler","Squamish","Vancouver","Pemberton","Seattle","Bellingham","Los Angeles","Boulder","Winnipeg","Ottawa","Toronto","Gatineau","Hull","Santa Barbara", "Park City", "Jackson","Canmore","Calgary","Banff","Blaine","Portland"].includes(location.city)) {
            deliveryText = `On-Site Assembly in Multiple Areas, Including ${location.city}`
          }
    else if(["Canada", "United States"].includes(location.country)) {
      if(location.country === 'United States')
        deliveryText = `Delivery Across the U.S., Including to ${location.city}`
      else
        deliveryText = `Delivery Across Canada, Including to ${location.city}`
    }
    if(deliveryText) {
      document.querySelectorAll('.geolocation-delivery-message').forEach((el, i) => {
        el.textContent = deliveryText;
    });
    }
      let manufacturedInText;
      if(location.country === 'United States')
        manufacturedInText = "Designed and Crafted in The Pacific Northwest";
      else
        manufacturedInText = "Designed and Crafted in Canada";

      
      if(manufacturedInText) {
      document.querySelectorAll('.geolocation-manufactured-in-message').forEach((el, i) => {
        el.textContent = manufacturedInText;
    });
  }
  }

  
  updateLocationTags()


const moneyFormat = '${{amount}}'
  function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    //number = (number / 1.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function displayLocalCurrency() {  
  document.querySelectorAll('.cad-usd').forEach((el, i) => {
   while (/\[\[USD-CAD (\d+)\|(\d+)\]\]/.test(el.innerHTML)){
     const [_, usdValue, cadValue] = /\[\[USD-CAD (\d+)\|(\d+)\]\]/.exec(el.innerHTML);
     if(Shopify.currency.active === 'USD'){
       el.innerHTML = el.innerHTML.replace(/\[\[USD-CAD \d+\|\d+\]\]/, formatMoney(usdValue))
     }
     else {
       el.innerHTML = el.innerHTML.replace(/\[\[USD-CAD \d+\|\d+\]\]/, formatMoney(cadValue))
     }
   }
  });;
}

  displayLocalCurrency();


  
 document.addEventListener('theme:variant:change', function(event){
  setTimeout(displayLocalCurrency, 500)
 });
})();


document.addEventListener("DOMContentLoaded", function () {
  (async function updateLocationTags() {
    try {
      const response = await fetch("https://pro.ip-api.com/json/?fields=country,regionName,zip,city&key=3vlBzaNm31rqDCj");
      const location = await response.json();


const city = location.city;
const region = location.regionName;  // This is the province or state
const country = location.country;

const cityPhoneMap = {
};

// Province/state-level fallback
const regionPhoneMap = {
  "Alberta": "(403) 917-1538",
  "Ontario": "(613) 416-5133",
  "British Columbia": "(778) 652-3569",
  "California": "(213) 271-2046",

// "Oregon": "(503) 404-4021"


  // Add other provinces if needed
};

const defaultPhoneCanada = "1 (800) 372-3061";
const defaultPhoneUS = "1 (800) 310-5099";

// Prioritize: City → Region → Country Default
window.localPhoneNumber = cityPhoneMap[city] || regionPhoneMap[region] || (country === "United States" ? defaultPhoneUS : defaultPhoneCanada);

      // Wait for the element to exist
      const waitForElement = (selector, timeout = 3000) => {
        return new Promise((resolve, reject) => {
          const interval = setInterval(() => {
            const el = document.querySelector(selector);
            if (el) {
              clearInterval(interval);
              resolve(el);
            }
          }, 100);
          setTimeout(() => {
            clearInterval(interval);
            reject(new Error("Timeout waiting for " + selector));
          }, timeout);
        });
      };

      try {
        await waitForElement('.geolocation-phone-number');
        document.querySelectorAll(".geolocation-phone-number").forEach(el => {
          el.textContent = window.localPhoneNumber;
        });
      } catch (e) {
        console.warn("Phone number element not found in time.");
      }

      document.querySelectorAll(".geolocation-call-link").forEach(link => {
        const tel = window.localPhoneNumber.replace(/[^0-9]/g, '');
        link.href = `tel:${tel}`;
        link.textContent = `Call ${window.localPhoneNumber}`;
      });
    } catch (error) {
      console.error("GeoPhone update failed:", error);
    }
  })();
});




